import React, { useState } from 'react';
import { Pen, Shield, Save } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { SignaturePad, SignatureDisplay } from '@/components/SignaturePad';
import { toast } from 'sonner';

export default function MaSignature() {
  const [signature, setSignature] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleSaveSignature = (signatureData) => {
    // Mock: In real app, this would call the API
    console.log('Saving signature:', signatureData.substring(0, 50) + '...');
    setSignature(signatureData);
    setIsEditing(false);
    toast.success('Signature enregistrée avec succès');
  };

  const handleDeleteSignature = () => {
    // Mock: In real app, this would call the API
    setSignature(null);
    toast.success('Signature supprimée');
  };

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-foreground flex items-center gap-3">
          <Shield className="w-8 h-8 text-primary" />
          Ma signature électronique
        </h1>
        <p className="text-muted-foreground mt-1">
          Gérez votre signature électronique pour les validations et signatures de documents
        </p>
      </div>

      {/* Info alert */}
      <Alert>
        <Shield className="h-4 w-4" />
        <AlertDescription>
          Votre signature électronique sera utilisée pour valider et signer les autorisations de conduite.
          Elle a la même valeur qu'une signature manuscrite dans le cadre des procédures internes.
        </AlertDescription>
      </Alert>

      {/* Signature section */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Signature</CardTitle>
              <CardDescription>
                {signature ? 'Modifiez ou supprimez votre signature' : 'Créez votre signature'}
              </CardDescription>
            </div>
            {!isEditing && !signature && (
              <Button onClick={() => setIsEditing(true)} className="gap-2">
                <Pen className="w-4 h-4" />
                Créer ma signature
              </Button>
            )}
          </div>
        </CardHeader>
        <CardContent>
          {isEditing ? (
            <SignaturePad
              onSave={handleSaveSignature}
              onCancel={() => setIsEditing(false)}
              existingSignature={signature}
            />
          ) : (
            <SignatureDisplay
              signature={signature}
              onEdit={() => setIsEditing(true)}
              onDelete={handleDeleteSignature}
            />
          )}
        </CardContent>
      </Card>

      {/* Info section */}
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Informations importantes</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <div className="flex gap-2">
            <span className="font-semibold text-foreground">•</span>
            <p>Votre signature est unique et personnelle</p>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold text-foreground">•</span>
            <p>Elle sera appliquée sur tous les documents que vous signez</p>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold text-foreground">•</span>
            <p>Vous pouvez la modifier à tout moment</p>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold text-foreground">•</span>
            <p>Toutes les modifications sont traçées dans l'historique</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
